import { apiClient } from "../../../lib";

export const raiseRiskApi = {

    createRisk: async ({ data }: { data: any }): Promise<any> => {
        const response = await apiClient.post(`/risks`, data);
        return response.data;
    },
    editRisk: async ({ riskId, data }: { riskId: string, data: any }): Promise<any> => {
        const response = await apiClient.put(`/risks/${riskId}`, data);
        return response.data;
    },

    createCause: async ({ riskId, data }: { riskId: string, data: any }): Promise<any> => {
        const response = await apiClient.post(`/risks/${riskId}/cause`, data);
        return response.data;
    },
    editCause: async ({ riskId, causeId, data }: { riskId: string, causeId: string, data: any }): Promise<any> => {
        const response = await apiClient.put(`/risks/${riskId}/cause/${causeId}`, data);
        return response.data;
    },
    fetchCauses: async ({ riskId }: { riskId: string }): Promise<any> => {
        const response = await apiClient.get(`/risks/${riskId}/cause`);
        return response.data;
    },

    createAssessmement: async ({ riskId, data }: { riskId: string, data: any }): Promise<any> => {
        const response = await apiClient.post(`/risks/${riskId}/assessment`, data);
        return response.data;
    },
    editAssessmement: async ({ riskId, assessmentId, data }: { riskId: string, assessmentId: string, data: any }): Promise<any> => {
        const response = await apiClient.put(`/risks/${riskId}/assessment/${assessmentId}`, data);
        return response.data;
    },
    fetchAssessments: async ({ riskId }: { riskId: string }): Promise<any> => {
        const response = await apiClient.get(`/risks/${riskId}/assessment`);
        return response.data;
    },

    createMitigation: async ({ riskId, data }: { riskId: string, data: any }): Promise<any> => {
        const response = await apiClient.post(`/risks/${riskId}/mitigation`, data);
        return response.data;
    },
    editMitigation: async ({ riskId, mitigationId, data }: { riskId: string, mitigationId: string, data: any }): Promise<any> => {
        const response = await apiClient.put(`/risks/${riskId}/mitigation/${mitigationId}`, data);
        return response.data;
    },
    fetchMitigations: async ({ riskId }: { riskId: string }): Promise<any> => {
        const response = await apiClient.get(`/risks/${riskId}/mitigation`);
        return response.data;
    }

};